import React from "react";
import { useTranslation } from "react-i18next";
import "./personalInterestListv2.css";

const PersonalInterestList = ({ list }) => {
	const { t } = useTranslation();

	return (
		<>
			{list && (
				<>
					{list.map((pi, i) => (
						<div
							key={i}
							className="studentDetails_modal_personalInterest_container"
						>
							<div className="row_container">
								<div className="">
									<div className="header">
										{t(
											"studentDetailsDialogue_body_tabProfile_tabExtraCurricular_title_header"
										)}
									</div>
									<div className="body">{pi.title || "-n/a-"}</div>
								</div>
							</div>
							<div className="row_container">
								<div className="">
									<div className="header">
										{t(
											"studentDetailsDialogue_body_tabProfile_tabExtraCurricular_description_header"
										)}
									</div>
									<div className="body">{pi.description || "-n/a-"}</div>
								</div>
							</div>
						</div>
					))}
					{list.length < 1 && " Not found.."}
				</>
			)}
		</>
	);
};

export default PersonalInterestList;
